import { Input, ChangeDetectorRef, Directive } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';

import { DateTransformPipe } from '@app/pipes/date-format.pipe';
import { PlaceNamePipe } from '@app/pipes/place-name.pipe';
import { tooltipTypes, textTooltipParents } from '@ux/entities/tooltip-types';
import { RecentSearchModel } from '@recent-searches/entities/recent-search';
import { getSimpleDateByRecent } from '@recent-searches/mappers/recent-dates.mapper';
import { RecentSearchDataType } from '@design-system/components/molecules/recent-search/entities/recent-search.types';

@Directive()
export class RecentSearchBaseComponent {

  @Input() search: RecentSearchModel;
  @Input() isMobile: boolean;
  @Input() id: number;
  @Input() dataType: RecentSearchDataType;

  public tooltipIconParent: string = textTooltipParents.HOTEL_PRICE_ICON;
  public tooltipType: string = tooltipTypes.TEXT;

  private readonly dateFormat = 'd MMM';

  constructor(
    protected router: Router,
    protected datePipe: DatePipe,
    protected dateTransformPipe: DateTransformPipe,
    protected placeNamePipe: PlaceNamePipe,
    protected changeDetector: ChangeDetectorRef
  ) { }

  public formatDate(date: string): string {
    const _date = this.formatDateBySearch(date);
    const _auxDate = new Date(_date);
    return !isNaN(_auxDate.getTime()) ?
      this.dateTransformPipe.transform(
        (this.datePipe.transform(new Date(_auxDate), this.dateFormat, 'UTC'))
      ) : '';
  }

  protected formatDateBySearch(date: string): string {
    return getSimpleDateByRecent(date);
  }
}
